export const i18nextInit = ({ es, en, pt }) => ({
  lng: 'en',
  debug: process.env.ENVIRONMENT !== 'PROD',
  detection: ['localStorage'],
  resources: {
    en: {
      translation: en,
    },
    pt: {
      translation: pt,
    },
    es: {
      translation: es,
    },
  },
})
